/*
 * @Description: 菜单（tab算为横向菜单）
 * @Date: 2024-11-05 09:46:11
 */

import { ref } from 'vue';
import { defineStore } from 'pinia';
import { Menus, Menu } from '@cTypes/user';
import { menuList } from '@/common/data-source/user/apis';
import { fieldsToMapping } from '@/utils/formatter';

const name = 'useMenuStoreSetup';
const useSetup = defineStore(
  name,
  () => {
    const menus = ref<Menus | []>([]);
    const menu = ref<Menu | null>(null);
    const menuUrls = ref<string[]>([]);
    const menuMapping = ref<{ [key in string]: Menu }>({});
    const setMenus = async () => {
      const { data } = await menuList();
      menus.value = data;
      menuMapping.value = fieldsToMapping(data, 'menuList', 'url');
      menuUrls.value = Object.keys(menuMapping.value);
      return Promise.resolve();
    };

    const routeForMenu = async (path: string) => {
      // TODO: 详情页面不会注册到菜单中，所以这个地方会为NULL。需要修改为如果不存在且是详情的路由需要添加个自定义菜单并有标识区分
      menu.value = menuMapping.value[path] || null;
    };
    return { menus, setMenus, menu, routeForMenu, menuUrls, menuMapping };
  },
  {
    persist: true
  }
);

export { useSetup, name };
